var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-6"},[_c('med-category-btns')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }